import('./bootstrap');

if (module.hot) {
  module.hot.accept();
}
